import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { decorateWith, withName } from 'helpers/decorator';
import media from 'decorators/Media/Media';
import { Heading } from 'components/Heading/Heading';
import { Section } from 'components/Section/Section';
import { messages } from './PressTestimonials.messages';

const mainImg = {
  desktop: require('static/img/mock-data/pricing/press/main-image-dektop.png'),
  mobile: require('static/img/mock-data/pricing/press/main-image.png'),
};

const quotes = [
  {
    copy: messages.quoteNYT,
    image: require('static/img/mock-data/pricing/press/logo-nyt.png'),
    source: 'The New York Times',
  },
  {
    copy: messages.quoteWG,
    image: require('static/img/mock-data/pricing/press/logo-wg.png'),
    source: 'Well + Good',
  },
];

export class PressTestimonialsUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.renderQuote = this.renderQuote.bind(this);
  }

  renderQuote(quote) {
    const { intl } = this.props;
    const { copy, image, source } = quote;
    return (
      <div key={source}>
        <blockquote className="PressTestimonials__quote">
          <FormattedMessage {...copy} />
        </blockquote>
        <img alt={intl.formatMessage(messages.altQuoteLogo, { source })} src={image} />
      </div>
    );
  }

  render() {
    const { intl, mediaQueryMd } = this.props;

    return (
      <Section className="PressTestimonials">
        <Heading className="PressTestimonials__header">
          <FormattedMessage {...messages.pressHeader} />
        </Heading>
        <div className="PressTestimonials__quotes">{quotes.map(this.renderQuote)}</div>
        <div className="PressTestimonials__mosaic">
          <img alt={intl.formatMessage(messages.altPressLogos)} src={mediaQueryMd ? mainImg.desktop : mainImg.mobile} />
        </div>
      </Section>
    );
  }
}

PressTestimonialsUnwrapped.propTypes = {
  mediaQueryMd: PropTypes.bool,
  intl: intlShape.isRequired,
};

export const PressTestimonials = decorateWith(injectIntl, media, withName('PressTestimonials'))(
  PressTestimonialsUnwrapped
);
